import { render } from "./AuthContainer.vue?vue&type=template&id=9839efa2&ts=true"
import script from "./AuthContainer.vue?vue&type=script&lang=ts"
export * from "./AuthContainer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__